.watermark-toggle {
  float: left;
  display: flex;
}
